import axios from "axios";
import config from "../config";

const Client = axios.create({
  baseURL: config.API.BASE_URL + config.API.suffix
});

export default Client;
